<template>
    <div style="width: 100%">
        <common-title-panel-vue title="에너지 비용 분석 결과"></common-title-panel-vue>
        <div class="row m-0">
            <!-- 용도별 비용 테이블 -->
            <div class="col-6 pl-0">
                <div class="table-responsive">
                    <table class="table table-bordered text-center">
                        <colgroup>
                            <col style="width: 15%" />
                            <col style="width: 30%" />
                            <col style="width: 25%" />
                            <col style="width: 30%" />
                        </colgroup>
                        <thead class="thead-dark">
                            <tr>
                                <th colspan="4">{{ "용도별 비용 (천원)" }}</th>
                            </tr>
                            <tr>
                                <th>{{ "구분" }}</th>
                                <th>{{ timeDsvn == "YEAR" ? "작년 (증감)" : "전월 (증감)" }}</th>
                                <th>{{ timeDsvn == "YEAR" ? "올해" : "당월" }}</th>
                                <th>{{ timeDsvn == "YEAR" ? "재작년 (증감)" : "전년 동월 (증감)" }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="hasUsageCostsData">
                                <tr
                                    v-for="item in formattedCosts.usageCosts"
                                    :key="`usage-${item.category}`"
                                    style="font-weight: bold"
                                >
                                    <td>{{ item.category }}</td>
                                    <td>
                                        {{ item.prevMonth }}&nbsp;
                                        <span
                                            :class="
                                                Number(item.prevDiff) > 0
                                                    ? 'text-blue'
                                                    : Number(item.prevDiff) < 0
                                                      ? 'text-danger'
                                                      : ''
                                            "
                                        >
                                            {{ `(${Number(item.prevDiff) > 0 ? "+" : ""}${item.prevDiff})` }}
                                        </span>
                                    </td>
                                    <td>{{ item.currentMonth }}</td>
                                    <td>
                                        {{ item.lastYearSameMonth }}&nbsp;
                                        <span
                                            :class="
                                                Number(item.lastYearDiff) > 0
                                                    ? 'text-blue'
                                                    : Number(item.lastYearDiff) < 0
                                                      ? 'text-danger'
                                                      : ''
                                            "
                                        >
                                            {{ `(${Number(item.lastYearDiff) > 0 ? "+" : ""}${item.lastYearDiff})` }}
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else class="empty-placeholder-row">
                                <td :colspan="4" class="empty-placeholder-cell">
                                    <div class="placeholder-content">
                                        <span class="placeholder-icon">
                                            <i class="fas fa-exclamation-circle"></i>
                                        </span>
                                        <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- 에너지원별 비용 테이블 -->
            <div class="col-6 pr-0">
                <div class="table-responsive">
                    <table class="table table-bordered text-center">
                        <colgroup>
                            <col style="width: 15%" />
                            <col style="width: 30%" />
                            <col style="width: 25%" />
                            <col style="width: 30%" />
                        </colgroup>
                        <thead class="thead-dark">
                            <tr>
                                <th colspan="4">{{ "에너지원별 비용 결과 (천원)" }}</th>
                            </tr>
                            <tr>
                                <th>{{ "구분" }}</th>
                                <th>{{ timeDsvn == "YEAR" ? "작년 (증감)" : "전월 (증감)" }}</th>
                                <th>{{ timeDsvn == "YEAR" ? "올해" : "당월" }}</th>
                                <th>{{ timeDsvn == "YEAR" ? "재작년 (증감)" : "전년 동월 (증감)" }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="hasEnergyCostsData">
                                <tr
                                    v-for="item in formattedCosts.energyCosts"
                                    :key="`energy-${item.category}`"
                                    style="font-weight: bold"
                                >
                                    <td>{{ item.category }}</td>
                                    <td>
                                        {{ item.prevMonth }}&nbsp;
                                        <span
                                            :class="
                                                Number(item.prevDiff) > 0
                                                    ? 'text-blue'
                                                    : Number(item.prevDiff) < 0
                                                      ? 'text-danger'
                                                      : ''
                                            "
                                        >
                                            {{ `(${Number(item.prevDiff) > 0 ? "+" : ""}${item.prevDiff})` }}
                                        </span>
                                    </td>
                                    <td>{{ item.currentMonth }}</td>
                                    <td>
                                        {{ item.lastYearSameMonth }}&nbsp;
                                        <span
                                            :class="
                                                Number(item.lastYearDiff) > 0
                                                    ? 'text-blue'
                                                    : Number(item.lastYearDiff) < 0
                                                      ? 'text-danger'
                                                      : ''
                                            "
                                        >
                                            {{ `(${Number(item.lastYearDiff) > 0 ? "+" : ""}${item.lastYearDiff})` }}
                                        </span>
                                    </td>
                                </tr>
                            </template>
                            <tr v-else class="empty-placeholder-row">
                                <td :colspan="4" class="empty-placeholder-cell">
                                    <div class="placeholder-content">
                                        <span class="placeholder-icon">
                                            <i class="fas fa-exclamation-circle"></i>
                                        </span>
                                        <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonTitlePanelVue from "../panels/CommonTitlePanel.vue";
export default {
    props: {
        costDableData: {
            type: Object,
            default: () => {},
        },
        timeDsvn: {
            type: String,
            default: "",
        },
    },
    components: { CommonTitlePanelVue },
    data() {
        return {};
    },
    computed: {
        formattedCosts() {
            const usageData = this.costDableData.usageData;
            const energySourceData = this.costDableData.energySourceData;

            // 천원 단위 변환 함수
            function _toStr(value) {
                if (typeof value === "number") {
                    return value < 1000 ? 0 : (value / 1000).toFixed(0).toLocaleString();
                }
                return value ?? 0;
            }

            function _calcDiff(current, previous) {
                const numCurrent = current !== null && current !== "" ? Number(current) : 0;
                const numPrevious = previous !== null && previous !== "" ? Number(previous) : 0;
                const diff = numPrevious - numCurrent;

                const scaled = Math.abs(diff) >= 1000 ? diff / 1000 : diff;
                return Number(scaled.toFixed(0).toLocaleString()) ?? null;
            }

            const usageCosts = Object.entries(usageData).map(([category, values]) => {
                const [prevMonth, currentMonth, lastYearSameMonth] = values;
                return {
                    category,
                    prevMonth: _toStr(prevMonth),
                    prevDiff: _calcDiff(currentMonth, prevMonth),
                    currentMonth: _toStr(currentMonth),
                    lastYearSameMonth: _toStr(lastYearSameMonth),
                    lastYearDiff: _calcDiff(currentMonth, lastYearSameMonth),
                };
            });

            const energyCosts = Object.entries(energySourceData).map(([category, values]) => {
                const [prevMonth, currentMonth, lastYearSameMonth] = values;
                return {
                    category,
                    prevMonth: _toStr(prevMonth),
                    prevDiff: _calcDiff(currentMonth, prevMonth),
                    currentMonth: _toStr(currentMonth),
                    lastYearSameMonth: _toStr(lastYearSameMonth),
                    lastYearDiff: _calcDiff(currentMonth, lastYearSameMonth),
                };
            });

            return {
                usageCosts,
                energyCosts,
            };
        },
        hasUsageCostsData() {
            if (!this.formattedCosts?.usageCosts || this.formattedCosts.usageCosts.length === 0) {
                return false;
            }

            // 모든 아이템의 값이 0인지 확인
            return this.formattedCosts.usageCosts.some((item) => {
                return (
                    Number(item.prevMonth) !== 0 ||
                    Number(item.currentMonth) !== 0 ||
                    Number(item.lastYearSameMonth) !== 0
                );
            });
        },
        hasEnergyCostsData() {
            if (!this.formattedCosts?.energyCosts || this.formattedCosts.energyCosts.length === 0) {
                return false;
            }

            // 모든 아이템의 값이 0인지 확인
            return this.formattedCosts.energyCosts.some((item) => {
                return (
                    Number(item.prevMonth) !== 0 ||
                    Number(item.currentMonth) !== 0 ||
                    Number(item.lastYearSameMonth) !== 0
                );
            });
        },
    },
    watch: {},
    mounted() {},
    created() {},
    methods: {},
};
</script>

<style scoped>
th,
td {
    vertical-align: middle !important;
    font-size: 0.75rem;
    padding: 5px;
}
thead th {
    background-color: #003366 !important;
    color: #fff;
}

.empty-placeholder-row {
    height: 200px;
}

.empty-placeholder-cell {
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
}

.placeholder-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: 200px;
    color: #999;
}

.placeholder-icon {
    font-size: 2rem;
    color: #ccc;
}

.placeholder-text {
    font-size: 0.9rem;
    color: #666;
}
</style>
